import { snakeCase } from "es-toolkit/compat";

/**
 * An abstraction of the es-toolkit/snakeCase function to conform to our internal naming conventions
 *
 * @param string The string to be formatted
 * @returns A snake-case string
 */
export const toSnakeCaseString = (string: string): string => snakeCase(string);
